import React, { useEffect } from 'react'
import { Alert } from 'components'
import { Form } from 'components/Form'
import { alerts as alertKeys } from 'keys'
import { useAlert } from 'components/Alerts/hooks'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import { validate } from 'pages/School/UploadAudio'
import { uploadAudioHooks } from '.'
import { initialize, reset } from 'redux-form'

const UploadAudioPopup = () => {
    const dispatch = useDispatch()

    const { setAlerts } = useAlert()

    const fields = uploadAudioHooks.useFormFields()
    const submitBtns = uploadAudioHooks.useSubmitBtns()
    const { formname, title } = uploadAudioHooks.constants

    useEffect(() => {
        return (() => {
            dispatch(reset(formname))
            dispatch(initialize(formname, {}));
        })
    }, [])

    return (
        <Alert
            systemUI
            title={title}
            footerActions={submitBtns}
            handleAlert={() => setAlerts(alertKeys.uploadAudio, false)}
        >
            <div>
                <Form
                    form={formname}
                    validations={validate}
                    fields={fields}
                    submit={() => { }}
                />
            </div>
        </Alert>
    )
}

export default UploadAudioPopup